import {
    WorldIcon,
    VehicleEquipmentAnalyticIcon,
    AIBasedAnalyticIcon,
    CentralizedCommandAnalyticIcon,
    RealTimePPEAnalyticIcon,
    ScalableMultiSiteAnalyticIcon,
    SmartIntrusionAnalyticIcon,
} from "../../constant";
import ContactUs from "../../components/ContactUs";
import StayInLoop from "../../components/StayInLoop";
import SolutionFourCardSwapSection from "../../components/SolutionFourCardSwapSection";
import WeAreIED from "../../components/WeAreIED";
import HeroAboutVideo from "../../components/HeroAboutVideo";
import AnimatedCardCrausal from "../../components/AnimatedCardCrausal";
import SolutionSliderView from "../../components/SolutionSliderView";
import VideoAnalyticsLanding from "../../components/Solution/VideoAnalyticsLanding";
import TogetherSection from "../../components/Solution/TogetherChange";

const slidesData = [
    {
        imgUrl: WorldIcon,
        title: "AI Safety Intelligence",
        subTitle: "Deliver proactive industrial safety with intelligent real-time video analytics and automated alert generation.",
        listName: "Experience the Future of Industrial Safety Monitoring",
        listItems: [
            "Detect PPE violations such as missing helmets, safety vests and masks in real time",
            "Generate instant alerts for unauthorized access and restricted zone intrusions",
            "Monitor unsafe worker activities and potential safety hazards proactively",
            "Enable faster incident response through centralized AI-driven alert management",
        ],
    },
    {
        imgUrl: WorldIcon,
        title: "Operational Awareness",
        subTitle: "Monitor people, machines and operational activities through AI-powered visual intelligence.",
        listName: "Transform Surveillance into Operational Intelligence",
        listItems: [
            "Track workforce movement, vehicle activity and equipment utilization across sites",
            "Visualize operational bottlenecks and movement patterns through live dashboards",
            "Monitor multiple surveillance feeds through a unified command center interface",
            "Improve operational coordination with real-time AI-powered situational awareness",
        ]
    },
    {
        imgUrl: WorldIcon,
        title: "Enterprise Video Intelligence",
        subTitle: "Scale intelligent monitoring across distributed industrial operations with centralized AI analytics.",
        listName: "Solutions tailored to your unique needs, no matter the scale.",
        listItems: [
            "Centralize monitoring and alert management across multiple industrial facilities",
            "Analyze incident trends and operational patterns using AI-powered video intelligence",
            "Improve enterprise-wide compliance, security monitoring and operational governance",
            "Scale intelligent video analytics seamlessly across distributed industrial environments",
        ],
    },
];



const AnimatedCardCrausalData = [
    {
        icon: RealTimePPEAnalyticIcon,

        title: "Real-Time PPE Detection",
        description:
            "Automatically detect missing helmets, safety vests, gloves, masks and other PPE violations in live video streams for proactive safety compliance",
    },
    {
        icon: SmartIntrusionAnalyticIcon,
        title: "Smart Intrusion & Restricted Zone Monitoring",
        description:
            "Identify unauthorized personnel entry, perimeter breaches and restricted-area access instantly with automated alerts and incident tracking.",
    },
    {
        icon: CentralizedCommandAnalyticIcon,
        title: "Centralized Command & Monitoring Dashboard",
        description: "Unify multiple camera feeds, live alerts, incident timelines and operational analytics into a single intelligent monitoring interface.",
    },
    {
        icon: AIBasedAnalyticIcon,
        title: " AI-Based Behavioral & Activity Analytics",
        description: "Detect unsafe worker behavior, loitering, crowd formation, fall incidents and operational anomalies using advanced AI video analytics",
    },
    {
        icon: VehicleEquipmentAnalyticIcon,
        title: " Vehicle & Equipment Movement Intelligence",
        description: "Track vehicle movement, overspeeding, unsafe equipment operations and traffic congestion across industrial facilities in real time.",
    },
    {
        icon: ScalableMultiSiteAnalyticIcon,
        title: "Scalable Multi-Site Video Intelligence Platform",
        description: "Monitor distributed industrial sites, warehouses, plants and mining operations through a centralized scalable video analytics ecosystem.",
    },
];

const FourCardsSwapcardData = [
    {
        title: "Intelligent Safety Monitoring",
        description:
            "Real-time alerts for proactive industrial safety and compliance",
    },
    {
        title: "Operational Intelligence ",
        description: "Enhance productivity through intelligent operational visibility"
    },
    {
        title: "Actionable Video Insights",
        description:
            "Scalable AI analytics platform for connected industrial operations",
    },
];
const tabsData = [
    {
        label: "About iED",
        key: "1",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Mission",
        key: "2",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Leadership",
        key: "3",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Differentiators",
        key: "4",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
    {
        label: "Technology",
        key: "5",
        videoUrl:
            "https://media.geeksforgeeks.org/wp-content/uploads/20231020155223/Full-Stack-Development-_-LIVE-Classes-_-GeeksforGeeks.mp4",
    },
];


export default function SolutionVideoAnalytics() {
    return (
        <>
            <VideoAnalyticsLanding />
            <AnimatedCardCrausal
                title={"Game-Changing Capabilities for Intelligent Video Analytics"}
                subTitle={"Empower industrial operations with AI-driven video intelligence designed to enhance safety, security, compliance and operational visibility across connected environments."}
                data={AnimatedCardCrausalData}
            />
            <SolutionFourCardSwapSection
                title={"Experience the Power of AI-Driven Video Analytics"}
                subTitle={"Unlock real-time operational visibility, strengthen industrial safety, and improve decision-making with intelligent video analytics designed for modern enterprises"}
                cardData={FourCardsSwapcardData}
            />
            <SolutionSliderView
                title={"Experience the Future of Industrial Safety Monitoring"}
                subTitle={"LUNE leverages advanced AI video analytics to detect PPE violations, unsafe behavior, restricted-area breaches and critical safety incidents in real time across industrial environments."}
                data={slidesData}
            />

            <WeAreIED solution={true} />
            <HeroAboutVideo tabsData={tabsData} isNetzero={true} />
            <TogetherSection title={"Transform Surveillance into Intelligent Operational Visibility "}
                subtitle={"LUNE empowers enterprises with AI-driven video analytics that convert live camera feeds into actionable operational intelligence, proactive safety monitoring and real-time situational awareness.Enhance industrial security, detect critical incidents instantly, improve compliance monitoring and optimize operational efficiency through scalable intelligent video analytics solutions."} />
            <ContactUs />
            <StayInLoop />
        </>
    );
}
